/**
 * 固定步长游戏循环：60Hz 累加器，单帧最多补 4 步防螺旋死亡。
 * timeScale 用于慢动作演出（bomb 等）。
 */

const STEP = 1 / 60;
const MAX_STEPS = 4;

export class Loop {
  /**
   * @param {{update: (dt: number) => void, render: () => void}} callbacks
   */
  constructor({ update, render }) {
    this.update = update;
    this.render = render;
    /** 时间缩放，1 = 正常速度 */
    this.timeScale = 1;
    /** 已执行的逻辑步总数 */
    this.frame = 0;
    this._running = false;
    this._accumulator = 0;
    this._lastTime = 0;
    this._rafId = 0;
    this._tick = this._tick.bind(this);
  }

  /** 启动循环（幂等）。 */
  start() {
    if (this._running) return;
    this._running = true;
    this._accumulator = 0;
    this._lastTime = performance.now();
    this._rafId = requestAnimationFrame(this._tick);
  }

  /** 停止循环。 */
  stop() {
    this._running = false;
    cancelAnimationFrame(this._rafId);
  }

  /** @private rAF 回调 */
  _tick(now) {
    if (!this._running) return;
    this._rafId = requestAnimationFrame(this._tick);
    let elapsed = (now - this._lastTime) / 1000;
    this._lastTime = now;
    if (elapsed > 0.25) elapsed = 0.25; // 长时间切后台后不大补
    this._accumulator += elapsed * this.timeScale;
    let steps = 0;
    while (this._accumulator >= STEP && steps < MAX_STEPS) {
      this.update(STEP);
      this.frame++;
      this._accumulator -= STEP;
      steps++;
    }
    if (steps === MAX_STEPS) this._accumulator = 0; // 丢弃积压，防螺旋死亡
    this.render();
  }
}
